import React from "react";

const PRODUCT_TABS = [
    { key: "with-campaign", label: "Products With Campaign" },
    { key: "without-campaign", label: "Products Without Campaign" },
];

const ProductCampaignTabs = ({
    activeTab,
    onTabChange,
    withCampaignCount = 0,
    withoutCampaignCount = 0,
}) => (
    <div
        role="tablist"
        aria-label="Product campaign coverage"
        className="grid h-11 min-h-11 w-full min-w-0 grid-cols-2 gap-1 rounded-lg border border-slate-200 bg-white p-1 shadow-sm"
    >
        {PRODUCT_TABS.map((tab) => {
            const isActive = activeTab === tab.key;
            const count =
                tab.key === "with-campaign"
                    ? withCampaignCount
                    : withoutCampaignCount;

            return (
                <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => onTabChange?.(tab.key)}
                    className={`flex h-full min-w-0 items-center justify-center rounded-lg px-2 text-center text-[10px] font-semibold leading-3 transition-colors sm:px-3.5 sm:text-sm sm:leading-5 ${
                        isActive
                            ? "bg-indigo-100 text-indigo-700 shadow-sm"
                            : "text-slate-600 hover:bg-indigo-50 hover:text-indigo-700"
                    }`}
                >
                    <span className="whitespace-normal sm:whitespace-nowrap">
                        {tab.label} ({count})
                    </span>
                </button>
            );
        })}
    </div>
);

export default ProductCampaignTabs;
